import { render, staticRenderFns } from "./place_bind_sel.vue?vue&type=template&id=a1356e6a&scoped=true"
import script from "./place_bind_sel.vue?vue&type=script&lang=js"
export * from "./place_bind_sel.vue?vue&type=script&lang=js"
import style0 from "./place_bind_sel.vue?vue&type=style&index=0&id=a1356e6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1356e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1356e6a')) {
      api.createRecord('a1356e6a', component.options)
    } else {
      api.reload('a1356e6a', component.options)
    }
    module.hot.accept("./place_bind_sel.vue?vue&type=template&id=a1356e6a&scoped=true", function () {
      api.rerender('a1356e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/place_bind_sel.vue"
export default component.exports